import type { CSSProperties } from 'react';
import { cn } from '../../../lib/cn';

const SIZES = { 6: 'size-1.5', 7: 'size-[7px]', 8: 'size-2', 10: 'size-2.5' } as const;

/**
 * Kropka koloru klienta (DESIGN §3: kolor klienta to dane, nie token). Bez koloru: neutralna kropka
 * (border/strong). Z `label` kropka jest ogłaszana czytnikom ekranu (np. w listach bez nazwy klienta obok).
 */
export function ClientDot({
  color,
  size = 8,
  label,
  className,
}: {
  color?: string | null;
  size?: keyof typeof SIZES;
  label?: string;
  className?: string;
}) {
  const style = color ? ({ backgroundColor: color } as CSSProperties) : undefined;
  return (
    <span
      {...(label ? { role: 'img', 'aria-label': label } : { 'aria-hidden': true })}
      style={style}
      className={cn('inline-block shrink-0 rounded-full', SIZES[size], !color && 'bg-line-strong', className)}
    />
  );
}
